if (!customElements.get('calc-shipping-rate-block')) {
    function getCurrentCountryCode() {
      const country = navigator.language ? navigator.language.slice(-2) : undefined;
      return country ? country.toUpperCase() : undefined;
    }
  
    function getCountryFlag(countryCode) {
      const countryMap = {
        'FR': '🇫🇷',
        'DE': '🇩🇪',
        'AT': '🇦🇹',
        'BE': '🇧🇪',
        'ES': '🇪🇸',
        'LU': '🇱🇺',
        'NL': '🇳🇱',
        'DK': '🇩🇰',
        'FI': '🇫🇮',
        'GR': '🇬🇷',
        'IE': '🇮🇪',
        'PT': '🇵🇹',
        'SE': '🇸🇪',
        'BG': '🇧🇬',
        'CY': '🇨🇾',
        'CZ': '🇨🇿',
        'EE': '🇪🇪',
        'HU': '🇭🇺',
        'LV': '🇱🇻',
        'LT': '🇱🇹',
        'MT': '🇲🇹',
        'PL': '🇵🇱',
        'SK': '🇸🇰',
        'SI': '🇸🇮',
        'IT': '🇮🇹',
      };

      return countryMap[countryCode];
    }
  
    function getShippingMethods(countryCode) {
      let methods;

      switch (countryCode) {
        case 'FR':
        case 'DE':
        case 'AT':
        case 'BE':
        case 'ES':
          methods = [
            { minSpent: 69.99, minDays: 2, maxDays: 6, price: 0 },
            { minSpent: 0, maxSpent: 24.99, minDays: 2, maxDays: 6, price: 8 },
            { minSpent: 25, maxSpent: 39.98, minDays: 2, maxDays: 6, price: 5.99 },
            { minSpent: 39.99, maxSpent: 69.98, minDays: 2, maxDays: 6, price: 4.50 },
          ];
          break;
        case 'LU':
        case 'NL':
          methods = [
            { minSpent: 99, minDays: 2, maxDays: 6, price: 0 },
            { minSpent: 0, maxSpent: 98.99, minDays: 2, maxDays: 6, price: 7.50 },
          ];
          break;
        case 'DK':
        case 'FI':
        case 'GR':
        case 'IE':
        case 'PT':
        case 'SE':
          methods = [
            { minSpent: 0, maxSpent: 98.99, minDays: 2, maxDays: 6, price: 9.90 },
            { minSpent: 99, maxSpent: 1000, minDays: 2, maxDays: 6, price: 8.70 },
          ];
          break;
        case 'BG':
        case 'CY':
        case 'CZ':
        case 'EE':
        case 'HU':
        case 'LV':
        case 'LT':
        case 'MT':
        case 'PL':
        case 'SK':
        case 'SI':
          methods = [
            { minSpent: 0, maxSpent: 98.99, minDays: 2, maxDays: 6, price: 11.50 },
            { minSpent: 99, maxSpent: 1000, minDays: 2, maxDays: 6, price: 9.90 },
          ];
          break;
        case 'IT':
          methods = [
            { minSpent: 69.99, minDays: 1, maxDays: 4, price: 0 },
            { minSpent: 0, maxSpent: 24.99, minDays: 1, maxDays: 4, price: 8 },
            { minSpent: 25, maxSpent: 39.98, minDays: 1, maxDays: 4, price: 5.99 },
            { minSpent: 39.99, maxSpent: 69.98, minDays: 1, maxDays: 4, price: 4.5 },
          ];
          break;
      }

      return methods && methods.length > 0 ? methods.map((method) => {
        if (method.price === 0) {
          return window.FoxThemeStrings.shippingMethodInfoFree.replace('{{ min_spent }}', method.minSpent).replace('{{ min_days }}', method.minDays).replace('{{ max_days }}', method.maxDays).replace('{{ price }}', method.price);
        }

        return window.FoxThemeStrings.shippingMethodInfo.replace('{{ min_spent }}', method.minSpent).replace('{{ max_spent }}', method.maxSpent).replace('{{ min_days }}', method.minDays).replace('{{ max_days }}', method.maxDays).replace('{{ price }}', method.price);
      }) : undefined;
    }
  
	function calculateShipping(button, container, zipCode, country, province) {
		const Notification = window.FoxTheme.Notification
		container.innerHTML = ''
		fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`)
			.then(res => res.json())
			.then(res => {
				if (res && res.shipping_rates) {
					const { shipping_rates } = res
					const { shippingRatesResult, noShippingRate } = window.FoxThemeStrings
					if (shipping_rates.length > 0) {
						const html = `${shippingRatesResult.replace('{{count}}', shipping_rates.length)}:`
						const text = generateDomFromString(html, 'p')
						text.classList.add('font-bold')

						container.appendChild(text)
						shipping_rates.map(rate => {
							const html = `${rate.name}: <strong>${formatMoney(rate.price, window.FoxThemeSettings.money_format)}</strong>`
							const message = generateDomFromString(html, 'p')
							container.appendChild(message)
						})
					} else {
						container.innerHTML = `<p>${noShippingRate}</p>`
					}
				} else {
					Object.entries(res).map(error => {
						Notification.show({
							target: container,
							method: 'appendChild',
							type: 'warning',
							message: error[1][0],
							last: 3000
						})
					})
				}
			})
			.catch(console.error)
			.finally(() => button.classList.remove('btn--loading'))
	}

	customElements.define('calc-shipping-rate-block', class FooterCalcShippingRates extends HTMLElement {
		constructor() {
			super()
			this.selectors = {
				button: '.btn-calc',
				zipCode: '[name="address[zip]"]',
				province: '[name="address[province]"]',
				country: '[name="address[country]"]',
				shippingRates: '.f-cart-drawer__shipping-message',
				countries: 'template',
                shippingMethods: '.estimated-shipping-methods',
                shippingMethodsList: '.shipping-methods-list',
                countryChooserButton: '#country-chooser-button',
                shippingCountry: '#shipping-country',
			}
			this.initAddress = false
			this.domNodes = queryDomNodes(this.selectors, this)
			this.collapsibleTab = this.querySelector('collapsible-tab')

			this.domNodes.button.addEventListener('click', this.fetchRates.bind(this))
			if (this.collapsibleTab) {
				setTimeout(() => {
					this.collapsibleTab.on('tabOpened', this.setupCountries.bind(this))
				}, 1000)
			}
			this.querySelector('.btn-cancel').addEventListener('click', this.handleClose.bind(this))

            this.showShippingMethods();
		}

		fetchRates(e) {
			e.preventDefault()
			this.domNodes.button.classList.add('btn--loading')
			const {zipCode, country, province} = this.domNodes
			calculateShipping(this.domNodes.button, this.domNodes.shippingRates, zipCode.value.trim(), country.value, province.value)
		}

		setupCountries() {
			if (this.initAddress) return false;
			this.domNodes.country.innerHTML = this.domNodes.countries.innerHTML
			if (Shopify && Shopify.CountryProvinceSelector) {
				// eslint-disable-next-line no-new
				new Shopify.CountryProvinceSelector(
					"AddressCountry",
					"AddressProvince",
					{
						hideElement: "AddressProvinceContainer",
					}
				);
				this.initAddress = true
			}
		}

		handleClose(e) {
			e.preventDefault()
			if (this.collapsibleTab) this.collapsibleTab.close()
		}

        showShippingMethods() {
          const countryCode = getCurrentCountryCode();
          if (!countryCode) return false;
          
          const methods = getShippingMethods(countryCode);
          if (!methods) return false;

          const countryFlag = getCountryFlag(countryCode);

          methods.forEach((method) => {
            const li = document.createElement('li');
            li.innerHTML = method;
            
            this.domNodes.shippingMethodsList.appendChild(li);
          });

          this.domNodes.shippingCountry.innerText = countryFlag + ' ' + countryCode;

          this.classList.add('has-estimated-shipping');
          this.collapsibleTab.style.display = 'none';
          this.domNodes.shippingMethods.style.display = 'block';
          this.domNodes.countryChooserButton.addEventListener('click', this.handleCountryChooserClick.bind(this));
        }

        handleCountryChooserClick(e) {
          this.domNodes.shippingMethods.style.display = 'none';
          this.collapsibleTab.style.display = 'unset';
          if (this.collapsibleTab) this.collapsibleTab.open();
        }
	})
}
